import UserNotifications from 'components/UserNotifications/UserNotifications';
export default UserNotifications;
